import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import { getCompetitorPriceLadderData } from 'gqlQueries/priceLadder';
import { priceLadderAttributeLevelChartParser, priceLadderAttributeLevelTableParser } from 'parser/priceLadderParser';
const errorMessage: string = 'Something went wrong!';

function useFetchCompetitorPriceLadder() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>(null);
    const [count, setCount] = useState(0);
    const variablesRef = useRef<any>({});
    const rawDataRef = useRef<any[]>([]);
    const { appConfig } = useContext(UserContext);
    const commonConfig = getConfig('commonConfig', appConfig);

    const [
        fetchCompetitorPriceLadder,
        { data: landscapeData, loading: landscapeDataLoading, error: landscapeDataError },
    ] = useLazyQuery(getCompetitorPriceLadderData, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPriceLadderCompetitorsAttributeLevelData } = payload;
            if (
                getPriceLadderCompetitorsAttributeLevelData &&
                'values' in getPriceLadderCompetitorsAttributeLevelData
            ) {
                const parsedChartData = priceLadderAttributeLevelChartParser(
                    getPriceLadderCompetitorsAttributeLevelData?.values,
                    appConfig,
                    getPriceLadderCompetitorsAttributeLevelData?.ppgName,
                );
                const parsedTableData = priceLadderAttributeLevelTableParser(
                    getPriceLadderCompetitorsAttributeLevelData?.values,
                    appConfig,
                );
                setData({ chartData: parsedChartData, tableData: parsedTableData });
            }
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setCount(0);
        rawDataRef.current = [];
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        count,
        data,
        setError: (message: any) => {
            onFetchError(message);
        },
        fetchCompetitorPriceLadder: (variables: any) => {
            variablesRef.current = variables.variables;
            //only set data to null if function is being called outside/without infinite scroll
            //if offset is equal to default offset, it means request is coming without infinite scroll
            // if (commonConfig.offset === variables.variables?.offset) {
            //     setData(null);
            //     rawDataRef.current = [];
            //     setError(null);
            // }
            setLoading(true);
            setError(null);
            fetchCompetitorPriceLadder(variables);
            // onFetchComplete(variables);
        },
    };
}

export { useFetchCompetitorPriceLadder };
